import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { MenuItem, MenuSeparator } from '../../components/Menu';
import addIcon from '../../icons/add.svg';
import collapseIcon from '../../icons/collapse.svg';
import expandIcon from '../../icons/expand.svg';
import historyIcon from '../../icons/history.svg';
import textIcon from '../../icons/text.svg';
import newTabIcon from '../../icons/editor/newTab.svg';
import trashIcon from '../../icons/trash.svg';
import TopicShape from '../../propTypes/TopicShape';
import topicPath from '../../utils/url/topicPath';

const propTypes = {
  isReorganizing: PropTypes.bool.isRequired,
  deleted: PropTypes.bool.isRequired,
  header: PropTypes.bool.isRequired,
  topic: TopicShape.isRequired,
  hasSubtopics: PropTypes.bool.isRequired,
  hasPosts: PropTypes.bool.isRequired,
  expanded: PropTypes.bool.isRequired,
  onExpandedChange: PropTypes.func.isRequired,
  onSubtopicCreate: PropTypes.func.isRequired,
  onTopicDeletedChange: PropTypes.func.isRequired,
  onRenameButtonClick: PropTypes.func.isRequired,
};

const TopicTreeCardMenu = ({
  isReorganizing,
  deleted,
  header,
  topic,
  hasSubtopics,
  hasPosts,
  expanded,
  onExpandedChange,
  onSubtopicCreate,
  onTopicDeletedChange,
  onRenameButtonClick,
}) => {
  const menuItems = [];

  if (!isReorganizing) {
    menuItems.push(
      <MenuItem
        key="viewTopicPage"
        icon={newTabIcon}
        to={topicPath(topic)}
        target="_blank"
      >
        View topic page
      </MenuItem>,
    );
  }

  if (!deleted && !header) {
    menuItems.push(
      <MenuItem
        key="collapse"
        icon={expanded ? collapseIcon : expandIcon}
        disabled={!hasSubtopics && !hasPosts}
        onClick={() => onExpandedChange(true)}
      >
        {expanded ? 'Collapse' : 'Expand'}
      </MenuItem>,
    );
  }

  if (isReorganizing && deleted) {
    menuItems.push(
      <MenuItem
        key="restore"
        icon={historyIcon}
        onClick={() => onTopicDeletedChange({ id: topic.id, deleted: false })}
      >
        Restore
      </MenuItem>,
    );
  }

  if (isReorganizing && !deleted) {
    if (menuItems.length) {
      menuItems.push(<MenuSeparator key="separator" />);
    }
    menuItems.push(
      <Fragment key="normalActions">
        <MenuItem
          icon={addIcon}
          onClick={() => {
            onSubtopicCreate({
              topicTempId: _.uniqueId(),
              parentId: topic.id,
            });
            if (!expanded) onExpandedChange();
          }}
        >
          Create subtopic
        </MenuItem>
        <MenuItem icon={textIcon} onClick={() => onRenameButtonClick()}>
          Rename
        </MenuItem>
        <MenuSeparator />
        <MenuItem
          icon={trashIcon}
          danger
          onClick={() => onTopicDeletedChange({ id: topic.id, deleted: true })}
        >
          Delete topic
        </MenuItem>
      </Fragment>,
    );
  }

  return <>{menuItems}</>;
};

TopicTreeCardMenu.propTypes = propTypes;

export default TopicTreeCardMenu;
